import { render, staticRenderFns } from "./tabs-bar.vue?vue&type=template&id=423ba029&scoped=true"
import script from "./tabs-bar.vue?vue&type=script&lang=js"
export * from "./tabs-bar.vue?vue&type=script&lang=js"
import style0 from "./tabs-bar.vue?vue&type=style&index=0&id=423ba029&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423ba029",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('423ba029')) {
      api.createRecord('423ba029', component.options)
    } else {
      api.reload('423ba029', component.options)
    }
    module.hot.accept("./tabs-bar.vue?vue&type=template&id=423ba029&scoped=true", function () {
      api.rerender('423ba029', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/tabs-bar.vue"
export default component.exports